__webpack_require__.p = "/reports-pie-chart-preset-4/referrals-hub/";